import { Card, CardContent } from "@/components/ui/card";
import { Users, DollarSign, TrendingUp, Gift, Clock } from "lucide-react";

export const AdminDashboardSection = ({ stats }) => {
  const statCards = [
    { icon: Users, label: "Total Users", value: stats?.total_users || 0, color: "blue" },
    { icon: DollarSign, label: "Total Invested", value: `$${(stats?.total_investments || 0).toLocaleString()}`, color: "emerald" },
    { icon: TrendingUp, label: "Active Investments", value: stats?.active_investments || 0, color: "amber" },
    { icon: Gift, label: "Referral Bonuses", value: `$${(stats?.total_referral_bonuses || 0).toLocaleString()}`, color: "purple" },
    { icon: Clock, label: "Pending", value: (stats?.pending_transactions || 0) + (stats?.pending_withdrawals || 0), color: "rose" },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4" data-testid="admin-stats-grid">
      {statCards.map((s) => (
        <Card key={s.label} className="bg-white border-slate-200">
          <CardContent className="p-5">
            <div className="flex items-center gap-4">
              <div className={`w-12 h-12 bg-${s.color}-100 rounded-xl flex items-center justify-center`}>
                <s.icon className={`w-6 h-6 text-${s.color}-600`} />
              </div>
              <div>
                <p className="text-2xl font-heading font-semibold text-slate-800">{s.value}</p>
                <p className="text-slate-500 text-sm">{s.label}</p>
              </div>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};
